import React, { useState, useEffect, useMemo } from 'react'; // <<-- IMPORTANTE: Importamos useMemo

// --- 1. DATOS DUMMY AMPLIADOS (18 PEDIDOS) ---
// NOTA: Los datos NO están ordenados aquí, el componente React se encargará de ordenarlos.
const DUMMY_ORDERS = [
    { id: 101, source: "Cliente: Venta Rápida #20", type: 'Para Llevar', time_minutes: 20, status: 'critical', items: [{ name: "Bacon Lovers", qty: 1, details: "+Ketchup" }, { name: "Papas Medianas", qty: 1, details: null }] },
    { id: 102, source: "DELIVERY: Didi #33", type: 'Delivery', time_minutes: 18, status: 'critical', items: [{ name: "Completo Italiano 🌭", qty: 2, details: "Mayo: Fuerte / +Chucrut" }, { name: "Té Helado", qty: 2, details: null }] },
    { id: 103, source: "Cliente: Rodrigo M.", type: 'Para Llevar', time_minutes: 15, status: 'warning', items: [{ name: "Hamburguesa Clásica", qty: 1, details: null }, { name: "Jugo Natural", qty: 1, details: null }] },
    { id: 104, source: "DELIVERY: PedidosYa #67", type: 'Delivery', time_minutes: 12, status: 'warning', items: [{ name: "Doble Queso Extremo", qty: 1, details: "+Salsa Ajo" }, { name: "Aros de Cebolla", qty: 1, details: null }] },
    { id: 105, source: "Cliente: Ana L.", type: 'Para Llevar', time_minutes: 10, status: 'warning', items: [{ name: "Combo Veggie", qty: 1, details: null }, { name: "Agua Benedictino", qty: 1, details: null }] },
    { id: 106, source: "Cliente: Venta Rápida #21", type: 'Para Llevar', time_minutes: 8, status: 'normal', items: [{ name: "Barros Luco", qty: 1, details: "Mayo: Suave" }, { name: "Cerveza Nacional", qty: 1, details: null }] },
    { id: 107, source: "DELIVERY: Uber Eats #45", type: 'Delivery', time_minutes: 5, status: 'normal', items: [{ name: "Churrasco Italiano", qty: 1, details: "Sin Tomate" }, { name: "Papas Cheddar & Bacon", qty: 1, details: null }] },
    { id: 108, source: "Cliente: Familia Soto", type: 'Para Llevar', time_minutes: 22, status: 'critical', items: [{ name: "Combo Familiar XL", qty: 1, details: null }, { name: "Brownie con Helado", qty: 4, details: null }] },
    { id: 109, source: "Cliente: Venta Rápida #22", type: 'Para Llevar', time_minutes: 19, status: 'warning', items: [{ name: "Nuggets (6)", qty: 2, details: null }, { name: "Milkshake Fresa", qty: 1, details: null }] },
    { id: 110, source: "DELIVERY: Didi #34", type: 'Delivery', time_minutes: 17, status: 'warning', items: [{ name: "Hamb. Pollo Crispy", qty: 1, details: "+Mostaza" }, { name: "Papas Familiares", qty: 1, details: null }] },
    { id: 111, source: "Cliente: Pedro R.", type: 'Para Llevar', time_minutes: 14, status: 'warning', items: [{ name: "Completo Italiano 🌭", qty: 1, details: "Mayo: Fuerte" }, { name: "Churros c/ Manjar", qty: 1, details: null }] },
    { id: 112, source: "Cliente: Venta Rápida #23", type: 'Para Llevar', time_minutes: 11, status: 'normal', items: [{ name: "Tequeños de Queso", qty: 1, details: null }, { name: "Bebida Fanta", qty: 1, details: null }] },
    { id: 113, source: "DELIVERY: PedidosYa #68", type: 'Delivery', time_minutes: 9, status: 'normal', items: [{ name: "Combo Pollo Crispy", qty: 1, details: null }, { name: "Agua Benedictino", qty: 1, details: null }] },
    { id: 114, source: "Cliente: Marcela D.", type: 'Para Llevar', time_minutes: 6, status: 'normal', items: [{ name: "Hamb. Clásica", qty: 2, details: "Mayo: Suave" }, { name: "Helado Soft", qty: 2, details: null }] },
    { id: 115, source: "DELIVERY: Uber Eats #46", type: 'Delivery', time_minutes: 25, status: 'critical', items: [{ name: "Triple BBQ Queso", qty: 1, details: null }, { name: "Papas Cheddar & Bacon", qty: 1, details: null }] },
    { id: 116, source: "Cliente: Venta Rápida #24", type: 'Para Llevar', time_minutes: 21, status: 'critical', items: [{ name: "Churrasco Italiano", qty: 1, details: "+Cebolla Caramelizada" }, { name: "Bebida Fanta", qty: 1, details: null }] },
    { id: 117, source: "Cliente: Venta Rápida #25", type: 'Para Llevar', time_minutes: 16, status: 'warning', items: [{ name: "Hamb. Veggie", qty: 1, details: "Sin palta" }, { name: "Jugo Natural", qty: 1, details: null }] },
    { id: 118, source: "DELIVERY: Didi #35", type: 'Delivery', time_minutes: 13, status: 'warning', items: [{ name: "Completo Italiano 🌭", qty: 1, details: "Mayo: Suave / +Chucrut" }, { name: "Cerveza Nacional", qty: 1, details: null }] },
];

const getStatusColor = (status) => {
    switch (status) {
        case 'critical': return '#dc3545';
        case 'warning': return '#ffc107';
        case 'normal': return '#28a745';
        default: return '#f8f9fa';
    }
};

const OrderCard = ({ order, onComplete, isSelected }) => {
    const timeColor = getStatusColor(order.status);
    
    const renderDetails = (details) => {
        if (!details) return null;
        return <div className="item-details" style={{color: '#adb5bd', fontSize: '0.9em', marginLeft: '20px'}}>{details}</div>;
    };

    return (
        <div className="col-md-4 mb-4">
            <div 
                className="order-card" 
                style={{
                    backgroundColor: isSelected ? '#17a2b8' : '#343a40',
                    border: `5px solid ${isSelected ? '#f8f9fa' : timeColor}`,
                    color: '#f8f9fa',
                    borderRadius: '10px',
                    padding: '10px',
                    minHeight: '400px',
                    display: 'flex',
                    flexDirection: 'column',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                }}
                onClick={() => onComplete(order.id)}
                tabIndex="0"
            >
                
                <div className="order-header" style={{
                    fontSize: '1.8rem', fontWeight: 'bold', textAlign: 'center', 
                    borderBottom: '3px solid #6c757d', paddingBottom: '5px', marginBottom: '10px'
                }}>
                    #{order.id} | {order.source}
                </div>

                <div style={{textAlign: 'center', fontSize: '1.2rem', marginBottom: '5px', color: '#6c757d'}}>
                    **TIPO:** {order.type}
                </div>

                <div className="order-time" style={{
                    fontSize: '3rem', fontWeight: '900', textAlign: 'center', color: isSelected ? '#f8f9fa' : timeColor,
                }}>
                    {order.time_minutes} min
                </div>

                <hr style={{backgroundColor: '#6c757d', height: '1px', border: 'none'}} />

                <div className="order-body flex-grow-1">
                    {order.items.map((item, index) => (
                        <div key={index} style={{marginBottom: '10px'}}>
                            <div className="order-item" style={{fontSize: '1.4rem'}}>
                                **{item.qty}x {item.name}**
                            </div>
                            {renderDetails(item.details)}
                        </div>
                    ))}
                </div>

                <button 
                    className={`btn status-button mt-auto btn-${isSelected ? 'light' : 'success'}`} 
                    onClick={(e) => {e.stopPropagation(); onComplete(order.id);}}
                    style={{fontSize: '1.2rem', textTransform: 'uppercase'}}
                >
                    MARCAR COMO LISTO (ENTER)
                </button>
            </div>
        </div>
    );
};


function KitchenDisplay() {
    const [orders, setOrders] = useState(DUMMY_ORDERS);
    const [selectedIndex, setSelectedIndex] = useState(0); 

    // --- LÓGICA DE ORDENAMIENTO POR URGENCIA (useMemo) ---
    // Esta función ordena los pedidos DE MAYOR tiempo de espera a MENOR (Descendente)
    const sortedOrders = useMemo(() => {
        // Creamos una copia del array de órdenes para no mutar el estado original
        return [...orders].sort((a, b) => b.time_minutes - a.time_minutes);
    }, [orders]); // Se recalcula solo cuando cambia la lista de 'orders'

    const handleOrderComplete = (id) => {
        console.log(`Orden ${id} marcada como lista.`);
        const newOrders = orders.filter(order => order.id !== id);
        setOrders(newOrders);
        
        // Ajustar el índice para no apuntar a una orden que ya no existe
        if (selectedIndex >= newOrders.length) {
            setSelectedIndex(Math.max(0, newOrders.length - 1));
        }
    };

    // --- LÓGICA DE NAVEGACIÓN ARCADE (TECLADO) ---
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (sortedOrders.length === 0) return;

            const maxIndex = sortedOrders.length - 1;
            
            switch (event.key) {
                case 'ArrowRight':
                    setSelectedIndex(prev => Math.min(maxIndex, prev + 1));
                    break;
                case 'ArrowLeft':
                    setSelectedIndex(prev => Math.max(0, prev - 1));
                    break;
                case 'ArrowDown':
                    // Moverse una fila (3 columnas)
                    setSelectedIndex(prev => Math.min(maxIndex, prev + 3)); 
                    break;
                case 'ArrowUp':
                    setSelectedIndex(prev => Math.max(0, prev - 3));
                    break;
                case 'Enter':
                    // Botón de acción: Completa la orden actualmente seleccionada
                    handleOrderComplete(sortedOrders[selectedIndex].id);
                    break;
                default:
                    return;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [sortedOrders, selectedIndex]); // Depende de la lista ordenada y el índice

    return (
        <div style={{backgroundColor: '#212529', minHeight: '100vh', padding: '20px'}}>
            <h1 style={{color: '#ffc107', textAlign: 'center', marginBottom: '20px'}}>
                KDS - Órdenes Takeaway & Delivery ({sortedOrders.length} Pedidos)
            </h1>

            <div style={{color: '#adb5bd', textAlign: 'center', marginBottom: '20px', fontSize: '1.2rem'}}>
                **NAVEGACIÓN ARCADE:** Flechas (Mover) | ENTER (Completar Orden)
            </div>

            <div className="container-fluid">
                <div className="row">
                    {/* Renderizamos la lista ORDENADA */}
                    {sortedOrders.map((order, index) => (
                        <OrderCard 
                            key={order.id} 
                            order={order} 
                            onComplete={handleOrderComplete} 
                            isSelected={index === selectedIndex}
                        />
                    ))}
                    {sortedOrders.length === 0 && (
                        <div className="col-12 text-center" style={{marginTop: '100px'}}>
                            <h2 style={{color: '#28a745'}}>✅ SIN ÓRDENES PENDIENTES ✅</h2>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default KitchenDisplay;